import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function capitalizeText(text: string): string {
  if (!text) return text;
  
  return text
    .toLowerCase()
    .split(' ')
    .map(word => {
      if (word.length === 0) return word;
      // Manejar casos especiales con guiones (Ana-Belén)
      if (word.includes('-')) {
        return word.split('-').map(part => 
          part.length > 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part
        ).join('-');
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}
